import { compact, round } from 'lodash';
import { HoldingClassRealisations } from '../../types';

const useFormatHoldingClassData = (
  holdingClassRealisations: HoldingClassRealisations,
) => {
  return compact(holdingClassRealisations).map((holdingClassRealisation) => {
    return {
      holdingClassId: holdingClassRealisation.holdingClassId,
      holdingClassName: holdingClassRealisation.name,
      unitsRealised: holdingClassRealisation.unitsSold ?? 0,
      receivedConsiderationTotal:
        holdingClassRealisation.cashConsiderationAmounts
          ?.receivedConsiderationTotal ?? 0,
      receivedConsiderationPerUnit: round(
        holdingClassRealisation.cashConsiderationAmounts
          ?.receivedConsiderationPerUnit ?? 0,
        10,
      ),
      escrowConsiderationTotal:
        holdingClassRealisation.cashConsiderationAmounts
          ?.escrowConsiderationTotal ?? 0,
      escrowConsiderationPerUnit: round(
        holdingClassRealisation.cashConsiderationAmounts
          ?.escrowConsiderationPerUnit ?? 0,
        10,
      ),
      earnoutConsiderationTotal:
        holdingClassRealisation.cashConsiderationAmounts
          ?.earnoutConsiderationTotal ?? 0,
      earnoutConsiderationPerUnit: round(
        holdingClassRealisation.cashConsiderationAmounts
          ?.earnoutConsiderationPerUnit ?? 0,
        10,
      ),
      withholdingTaxPayable:
        holdingClassRealisation.cashConsiderationAmounts
          ?.withholdingTaxPayable ?? 0,
    };
  });
};
export default useFormatHoldingClassData;
